(ns client-portal.client.voice-insights.items.charts.data
  (:require [client-portal.client.concepts.data :as concepts.d]
            [client-portal.client.voice-insights.data :as vi.d]
            [client-portal.client.vi.components.tag :as tag]
            [client-portal.client.voice-insights.items.data :as items.d]
            [shared.core.reactive :as re]
            [shared.core.util :as util]
            [shared.core.constants :as constants]
            [cljs-time.format :as t.f]
            [clojure.string :as s]))

(def root-path [:voice-insights :items :charts])
(def charts-data-path (conj root-path :data))
(def charts-settings-path (conj root-path :settings))

(defn build-total-counts [d k]
  (->> d
       (group-by k)
       (map (fn [[k vals]] [k (apply + (map :count vals))]))
       (into {})))

(defn total-counts->top-20-keys [total-counts]
  (->> total-counts
       (sort-by second)
       (reverse)
       (keys)
       (take 20)
       (into #{})))

(defn sort-items-by-count-or-value [items]
  (sort-by #(or (:count %) (:value %)) > items))

(defn items->top-20-keys [items]
  (->> items
       (sort-items-by-count-or-value)
       (take 20)
       (map :item)
       (into #{})))

(defn time-of-day->filter-val [tod]
  (-> tod
      (s/replace " " "")
      (s/replace "AM" "am")
      (s/replace "PM" "pm")))

(defn transf-upsell-data [upsell-type customer-upsell-data]
  (when (not-empty customer-upsell-data)
    (let [all-data (->> customer-upsell-data
                        (group-by :item)
                        (mapv (fn [[item item-results]]
                                (merge {:name item
                                        :total (reduce + (map :count item-results))}
                                       (->> item-results
                                            (sort-by (fn [a _]
                                                       (if (= (some-> (:result a) (s/lower-case)) "accept")
                                                         -1
                                                         1)))
                                            (map (fn [{:keys [count result]}]
                                                   [(str upsell-type "." result) count]))
                                            (into {})))))
                        (sort-by :total)
                        (reverse))]
      {:data all-data})))

(defn transf-charts-data [d]
  (-> d
      (update :unavailable-items-by-reason
              (fn [unavailable-items-by-reason]
                (when (not-empty unavailable-items-by-reason)
                  (let [total-counts (build-total-counts unavailable-items-by-reason :item)]
                    {:data (->> unavailable-items-by-reason
                                (mapv (fn [r]
                                        (assoc r :reason (tag/tag->display-name {:value (:reason r)})
                                                 :reason-raw (:reason r)
                                                 :total-count (get total-counts (:item r)))))
                                (sort-by :total-count)
                                (reverse))
                     :top-20-keys (total-counts->top-20-keys total-counts)}))))
      (update :unavailable-items-by-time
              (fn [unavailable-items-by-time]
                (when (not-empty unavailable-items-by-time)
                  (let [grouped-by-type (group-by :time-grouping unavailable-items-by-time)
                        process-grouping (fn [grouping-key time-key sort-fn display-fn]
                                           (let [data (get grouped-by-type grouping-key)
                                                 total-counts (build-total-counts data :item)]
                                             {:data (->> data
                                                         (sort-by sort-fn)
                                                         (mapv (fn [r]
                                                                 (assoc r time-key (display-fn (:time-value r))
                                                                          :total-count (get total-counts (:item r))))))
                                              :top-20-keys (total-counts->top-20-keys total-counts)}))]
                    {:hourly (process-grouping "hourly" :hour
                                               #(-> % :time-value (util/parse-int))
                                               util/readable-hour-num)
                     :daily (process-grouping "daily" :day
                                              :time-value
                                              (fn [date-str]
                                                (let [parsed-date (t.f/parse (t.f/formatter "yyyy-MM-dd") date-str)]
                                                  (t.f/unparse (t.f/formatter "MMM dd, EEE") parsed-date))))
                     :day-of-week (process-grouping "day-of-week" :day-of-week
                                                    (fn [r]
                                                      (get constants/days-of-the-week-map (:time-value r) 7))
                                                    identity)}))))
      (update :unavailable-reasons-by-time
              (fn [unavailable-reasons-by-time]
                (when (not-empty unavailable-reasons-by-time)
                  (let [grouped-by-type (group-by :time-grouping unavailable-reasons-by-time)
                        process-grouping (fn [grouping-key time-key sort-fn display-fn]
                                           (let [data (get grouped-by-type grouping-key)
                                                 total-counts (build-total-counts data :time-value)]
                                             {:data (->> data
                                                         (sort-by sort-fn)
                                                         (mapv (fn [r]
                                                                 (assoc r time-key (display-fn (:time-value r))
                                                                          :reason (tag/tag->display-name {:value (:reason r)})
                                                                          :reason-raw (:reason r)
                                                                          :total-count (get total-counts (:time-value r))))))
                                              :top-20-keys (total-counts->top-20-keys total-counts)}))]
                    {:hourly (process-grouping "hourly" :hour
                                               #(-> % :time-value (util/parse-int))
                                               util/readable-hour-num)
                     :daily (process-grouping "daily" :day
                                              :time-value
                                              (fn [date-str]
                                                (let [parsed-date (t.f/parse (t.f/formatter "yyyy-MM-dd") date-str)]
                                                  (t.f/unparse (t.f/formatter "MMM dd, EEE") parsed-date))))
                     :day-of-week (process-grouping "day-of-week" :day-of-week
                                                    (fn [r]
                                                      (get constants/days-of-the-week-map (:time-value r) 7))
                                                    identity)}))))
      (update :customer-upsell-results-by-time
              (fn [upsell-results-by-time]
                (when (not-empty upsell-results-by-time)
                  (let [grouped-by-type (group-by :time-grouping upsell-results-by-time)
                        process-grouping (fn [grouping-key time-key sort-fn display-fn]
                                           (let [data (get grouped-by-type grouping-key)
                                                 total-counts (build-total-counts data :time-value)]
                                             {:data (->> data
                                                         (sort-by sort-fn)
                                                         (mapv (fn [r]
                                                                 (assoc r time-key (display-fn (:time-value r))
                                                                          :result (tag/tag->display-name {:value (:result r)})
                                                                          :result-raw r
                                                                          :total-count (get total-counts (:time-value r))))))
                                              :top-20-keys (total-counts->top-20-keys total-counts)}))]
                    {:hourly (process-grouping "hourly" :hour
                                               #(-> % :time-value (util/parse-int))
                                               util/readable-hour-num)
                     :daily (process-grouping "daily" :day
                                              :time-value
                                              (fn [date-str]
                                                (let [parsed-date (t.f/parse (t.f/formatter "yyyy-MM-dd") date-str)]
                                                  (t.f/unparse (t.f/formatter "MMM dd, EEE") parsed-date))))
                     :day-of-week (process-grouping "day-of-week" :day-of-week
                                                    (fn [r]
                                                      (get constants/days-of-the-week-map (:time-value r) 7))
                                                    identity)}))))
      (update :customer-upsell-add-on #(transf-upsell-data "add-on" %))
      (update :customer-upsell-size #(transf-upsell-data "size" %))
      (update :customer-upsell-combo #(transf-upsell-data "combo" %))
      (update :crew-upsell-combo-items
              (fn [crew-upsell-combo-items]
                (when (not-empty crew-upsell-combo-items)
                  (let [sorted-items (sort-items-by-count-or-value crew-upsell-combo-items)
                        total (reduce + (map :count crew-upsell-combo-items))
                        top-20-keys (items->top-20-keys crew-upsell-combo-items)]
                    {:data (mapv (fn [item]
                                   (assoc item
                                     :name (:item item)
                                     :value (:count item)
                                     :fill (items.d/item-color item)))
                                 sorted-items)
                     :total total
                     :top-20-keys top-20-keys}))))
      (update :question-items
              (fn [question-items]
                (when (not-empty question-items)
                  (let [question-items (mapv (fn [{:keys [question-value] :as i}]
                                               (assoc i :question-value (tag/tag->display-name {:value question-value})
                                                        :question-value-raw question-value))
                                             question-items)
                        total-counts (build-total-counts question-items :item)
                        top-20-keys (total-counts->top-20-keys total-counts)]
                    {:data question-items
                     :top-20-keys top-20-keys}))))))

(re/reg-auth0-loader
  :vi-items/load-charts-data
  charts-data-path
  (fn [db _]
    (when (concepts.d/current-concept-id db)
      {:method :post
       :url "/api/vi/items/charts"
       :json-params (vi.d/base-query-args db {})}))
  :transf #(or (some-> % :body (util/->kebab-case-keywords) (transf-charts-data)) [])
  :error-transf (fn [] []))

(re/reg-auth0-load-sub
  :vi-items/charts-data-
  charts-data-path
  :vi-items/load-charts-data)
